const MapModal = () => import("@/components/common/mapModal/Index");
const newGroupingPage = () => import("./newGroup.vue");
const photoGraphic = () => import("@/components/common/photoGraphic/index.vue");
import * as viewpointMap from "./viewpointMap.js";

import {
  BimViewPntsGroupingDetail,
  BimViewPntsGroupingAdd,
  BimViewPntsGroupingDelete,
  BimViewPntsGroupingEdit,
  BimViewPntsDetailAdd,
  BimViewPntsDetailDelete,
  BimViewPntsDetailEdit,
} from "@/api/api";
import { set } from "lodash";

export default {
  name: "viewpoint",
  components: {
    MapModal,
    newGroupingPage,
    photoGraphic,
  },
  props: {
    selectedScene: Object, //从父组件传递过来的当前选中的项目item
  },
  data() {
    return {
      viewpoint: {
        title: "视点",
        id: "viewpoint",
      },
      modalNode: {
        viewpoint: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            // x: 106,
            // y: -376,
            x: 55,
            y: -260,
            // unit: "px", // 默认px
          },
          width: "202px",
          // auto 自适应
          // height: `${document.querySelector(".cesium-widget").offsetHeight - 30}px`, // 配置模态框中心高度
          height: `${document.querySelector("#mars3d-container").offsetHeight -
            140}px`,
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "id", // id和ref使用的同一个
            name: "title", // 树的展示字段 默认name
            class: "tree-image", //
            // imageError: "暂无数据",
            expand: false,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            checkeArr: [],
            isExpandList: window.sessionStorage.getItem("savePerspectiveId")
              ? [parseInt(window.sessionStorage.getItem("savePerspectiveId"))]
              : [],
            search: {
              keywords: "title", // 搜素配置关键字 默认是name
            },
            i_icon: {
              // level_1: "las la-plane",
            },
            checkBox: false,
            checkBoxClick: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
      newPageShow: false,
      selectTreeData: null,
      editTreeData: null,
      shidianArr: [],
      initialIndex: 0,
      setIntervals: null,
      setTimeouts: null,
      contrastTime: null,
      viewpointNode: {
        newGroupingCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 55,
          //   y: -650,
          // },
          // width: "450px", // 宽度配置 默认450px
          height: "300px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      viewpointRules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
      },
      viewpointForm: {
        name: "",
        speed: null,
        lastingTime: null,
        id: "",
      },
      isGlobal: true,
      ifPhotoGraphic: false,
      startingPoint: false,
      childrenEditData: null,
      viewpointNodeShow: false,
    };
  },
  methods: {
    getData() {
      BimViewPntsGroupingDetail({
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
      })
        .then((res) => {
          if (res.data.code == 200) {
            // 二级分组新增编辑删除
            const operateGroupingList = [
              {
                i_icon: "small-operation-btn el-icon-video-play",
                click: (e) => this.openSimulation(e),
              },
              {
                i_icon: "small-operation-btn el-icon-edit",
                click: (e) => this.editTree(e),
              },
              {
                i_icon: "small-operation-btn el-icon-delete",
                click: (e) => this.deleteTree(e),
              },
            ];
            if (res.data.data.length > 0) {
              res.data.data.forEach((item, index) => {
                item.operate = operateGroupingList;
                item.style = "position: relative;right: -105px;top:3px";
                if (item.children.length > 0)
                  this.recursion(item.children, index);
              });
            }
            this.modalNode.viewpoint.content.treeDataJson = res.data.data;
            this.modalNode.viewpoint.content.isExpandList = window.sessionStorage.getItem(
              "savePerspectiveId"
            )
              ? [parseInt(window.sessionStorage.getItem("savePerspectiveId"))]
              : [];
            if (this.selectTreeData) {
              setTimeout(() => {
                this.$refs.MapModal.$refs.modalTree[0].setCurrentKey(
                  this.selectTreeData.id
                );
              }, 10);
            }
          }
        })
        .catch((err) => {});
    },
    // 递归处理树数据
    recursion(data, index) {
      const threeObj = [
        {
          i_icon: "small-operation-btn el-icon-edit",
          click: (e) => this.childrenEdit(e),
        },
        {
          i_icon: "small-operation-btn el-icon-delete",
          click: (e) => this.childrenDelete(e),
        },
      ];
      data.forEach((item, i) => {
        item._index = i;
        item.parentIndex = index;
        item.operate = threeObj;
        item.style = "position: relative;right: -95px;top:1px";
        item.image = item.detail.image;
      });
      // console.log(checkeArr);
      // return data;
    },
    savePoint() {
      let is = true;
      this.modalNode.viewpoint.content.treeDataJson.forEach((el) => {
        if (this.selectTreeData?.id == el.id) {
          const camera = this.$GLOBAL.map.getCameraView();
          is = false;
          //视点插入当前视角图片
          this.$GLOBAL.map
            .expImage({
              download: false,
              width: 300,
            })
            .then((result) => {
              console.log(result, "resultresultresult");
              BimViewPntsDetailAdd({
                GroupId: this.selectTreeData.id,
                Name: "视点" + this.getTime(),
                lng: camera.lng,
                lat: camera.lat,
                alt: camera.alt,
                heading: camera.heading,
                pitch: camera.pitch,
                image: result.image,
              }).then((res) => {
                this.$message({
                  type: "success",
                  message: "保存成功!",
                });
                this.getData();
              });
            });
        }
      });
      if (!this.selectTreeData) {
        this.$message({
          message: "请先选中一条视点组！",
          type: "warning",
        });
        return;
      }
      if (is) {
        this.$message({
          message: "请先选中一条视点组！",
          type: "warning",
        });
      }
    },
    addGrouping() {
      this.newPageShow = true;
      // vMap.setCameraViewList();
    },
    closeNewGrouping() {
      this.newPageShow = false;
      this.editTreeData = null;
    },
    checkBoxClick(e) {
      console.log(e);
    },
    nodeClick(e, node) {
      console.log(e.id);
      if (node.expanded) {
        window.sessionStorage.setItem("savePerspectiveId", e.id);
      } else {
        // window.sessionStorage.setItem("savePerspectiveId", null);
        sessionStorage.removeItem("savePerspectiveId");
      }
      // window.savePerspectiveId = e.id;

      this.selectTreeData = e;
      if (e.detail) {
        this.$GLOBAL.map.setCameraView({
          lat: e.detail.lat,
          lng: e.detail.lng,
          alt: e.detail.alt,
          heading: e.detail.heading,
          pitch: e.detail.pitch,
        });
      }
    },
    plotItem_click() {
      this.$emit("plotItem_click");
      this.$emit("plotItemClose", "viewpoint");
    },
    externalInit() {},
    onSubmitGroupName(form) {
      if (this.editTreeData) {
        BimViewPntsGroupingEdit({
          GroupId: this.editTreeData.id,
          Name: form.name,
          roamSpeed: form.roamSpeed,
          showPath: form.showPath,
          isglobal: form.isglobal,
          customSpeed: form.customSpeed,
        }).then((res) => {
          this.getData();
          this.newPageShow = false;
          this.editTreeData = null;
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
        });
      } else {
        BimViewPntsGroupingAdd({
          ProjectId: window.sessionStorage.getItem("nowProjectId"),
          name: form.name,
          showPath: form.showPath,
          roamSpeed: form.roamSpeed,
          isglobal: form.isglobal,
          customSpeed: form.customSpeed,
        }).then((res) => {
          if (res.data.code == 200) {
            this.getData();
            this.newPageShow = false;
          }
          this.$message({
            type: "success",
            message: "新建成功!",
          });
        });
      }
    },
    openSimulation(e) {
      if (!e.children.length) return;
      this.$GLOBAL.map.setCameraView(
        {
          lat: e.children[0].detail.lat,
          lng: e.children[0].detail.lng,
          alt: e.children[0].detail.alt,
          heading: e.children[0].detail.heading,
          pitch: e.children[0].detail.pitch,
        },
        {
          complete: () => {
            this.startFlight(e);
          },
        }
      );
      // this.$GLOBAL.map.setCameraViewList([
      //   {
      //     lat: e.children[0].detail.lat,
      //     lng: e.children[0].detail.lng,
      //     alt: e.children[0].detail.alt,
      //     heading: e.children[0].detail.heading,
      //     pitch: e.children[0].detail.pitch,
      //     duration: 2,
      //   },
      // ]);
    },
    startFlight(e) {
      viewpointMap.showPath(false);
      this.initialIndex = 0;
      let roamSpeed;
      if (e.isGlobal) {
        //打开了方案全局速度
        roamSpeed = e.roamSpeed ? e.roamSpeed : e.customSpeed;
      }
      // this.$message({
      //   message: "方案速度未选择!",
      //   type: "warning",
      // });
      // return;

      this.contrastTime = roamSpeed * 1000;
      let arr = [];
      e.children.forEach((el) => {
        if (!e.isGlobal) {
          // 8是默认中等速度
          roamSpeed = el.viewPointLastingTime ? el.viewPointLastingTime : 8;
        }
        arr.push({
          lng: el.detail.lng,
          lat: el.detail.lat,
          alt: el.detail.alt,
          heading: el.detail.heading,
          pitch: el.detail.pitch,
          duration: roamSpeed,
          stop: 0,
          onEnd: () => {
            this.initialIndex += 1;
            // 重新计算时间
            this.contrastTime = roamSpeed * 1000;
          },
        });
      });
      this.shidianArr = arr;
      arr[0].stop = 1;
      this.$GLOBAL.map.setCameraViewList(arr, {
        maximumHeight: 10,
        complete: () => {
          this.$message({
            type: "success",
            message: "视点播放完毕",
          });
          viewpointMap.showPath(true);
          clearInterval(this.setTimeouts);
          clearInterval(this.setIntervals);
        },
      });
      let judgment = false;

      this.setTimeouts = setInterval(() => {
        this.contrastTime = this.contrastTime - 100;
      }, 100);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.setTimeouts);
        clearInterval(this.setIntervals);
      });
      document.onkeydown = (e) => {
        let key = window.event.keyCode;
        if (key == 32) {
          // 空格
          if (judgment) {
            if (this.shidianArr.length) {
              let arr = this.shidianArr.slice(
                this.initialIndex,
                this.shidianArr.length
              );
              if (arr.length) {
                // this.$GLOBAL.map.setCameraView(
                //   {
                //     lat: arr[0].lat,
                //     lng: arr[0].lng,
                //     alt: arr[0].alt,
                //     heading: arr[0].heading,
                //     pitch: arr[0].pitch,
                //   },
                //   {
                //     duration: 0,
                //   }
                // );
                arr[0].duration = this.contrastTime / 1000;
                this.setTimeouts = setInterval(() => {
                  this.contrastTime =
                    this.contrastTime > 100
                      ? this.contrastTime - 100
                      : this.contrastTime;
                }, 100);
                this.$GLOBAL.map.setCameraViewList(arr, {
                  maximumHeight: 10,
                  complete: () => {
                    this.$message({
                      type: "success",
                      message: "视点播放完毕",
                    });
                    viewpointMap.showPath(true);
                    clearInterval(this.setTimeouts);
                    clearInterval(this.setIntervals);
                  },
                });
              }
            }
          } else {
            // 暂停
            clearInterval(this.setTimeouts);
            clearInterval(this.setIntervals);

            this.$GLOBAL.map.cancelFlyTo();
          }
          judgment = !judgment;
        }
        if (key == 27) {
          // Esc
          if (this.setTimeouts) {
            clearInterval(this.setTimeouts);
            clearInterval(this.setIntervals);
            this.setTimeouts = null;
            this.$GLOBAL.map.cancelFlyTo();
            this.initialIndex = 0;
            this.shidianArr = [];
            this.$message({
              type: "success",
              message: "退出视点漫游!",
            });
            viewpointMap.showPath(true);
          }
        }
      };
    },
    editTree(e) {
      this.editTreeData = e;
      this.newPageShow = true;
      setTimeout(() => {
        this.$refs.newGroupingPage.form.name = e.title;
        this.$refs.newGroupingPage.form.roamSpeed = e.roamSpeed;
        this.$refs.newGroupingPage.form.showPath = e.showPath;
        this.$refs.newGroupingPage.form.isglobal = e.isGlobal;
        this.$refs.newGroupingPage.form.customSpeed = e.customSpeed
          ? e.customSpeed
          : 0;
        if (e.isGlobal && e.customSpeed && e.customSpeed > 0) {
          this.$refs.newGroupingPage.customize = "customize";
        }
        if (e.showPath) {
          if (e.children.length) {
            viewpointMap.openPath(e.children);
          }
        } else {
          viewpointMap.clearPath();
        }
      }, 200);
    },
    deleteTree(e) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          BimViewPntsGroupingDelete({
            GroupId: e.id,
          }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    childrenDelete(e) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          BimViewPntsDetailDelete({
            ViewPointId: e.id,
          }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    childrenEdit(e) {
      console.log(e);
      this.childrenEditData = e;
      this.startingPoint = e._index == 0 ? true : false;
      // this.viewpointNode.newGroupingCategory.show = true;
      this.viewpointNodeShow = true;
      this.viewpointForm.name = "";
      this.viewpointForm.name = e.title;
      this.viewpointForm.id = e.id;
      this.viewpointForm.speed = e.viewPointSpeed ? e.viewPointSpeed : 0;
      this.viewpointForm.lastingTime = e.viewPointLastingTime
        ? e.viewPointLastingTime
        : 0;
      this.ifPhotoGraphic = true;
      this.isGlobal = e.isGlobal;
      if (e.isGlobal) {
        this.calculation("time");
        this.viewpointForm.lastingTime = e.roamSpeed;
      } else {
        if (!e.viewPointLastingTime) {
          this.viewpointForm.lastingTime = 8;
          this.calculation("time");
        }
      }
    },
    calculation(v) {
      if (
        (v == "time" && this.viewpointForm.lastingTime == 0) ||
        (v == "speed" && this.viewpointForm.speed == 0)
      ) {
        return;
      }
      var point1, point2;
      point1 = this.modalNode.viewpoint.content.treeDataJson[
        this.childrenEditData.parentIndex
      ].children[this.childrenEditData._index - 1].detail;
      point2 = this.modalNode.viewpoint.content.treeDataJson[
        this.childrenEditData.parentIndex
      ].children[this.childrenEditData._index].detail;

      var from = turf.point([point1.lng, point1.lat]);
      var to = turf.point([point2.lng, point2.lat]);
      var options = { units: "kilometers" };

      var distance = turf.distance(from, to, options);
      if (v == "time") {
        this.viewpointForm.speed = parseInt(
          (distance.toFixed(1) * 1000) / this.viewpointForm.lastingTime
        );
      } else {
        this.viewpointForm.lastingTime = parseInt(
          (distance.toFixed(1) * 1000) / this.viewpointForm.speed
        );
      }
    },
    savePerspective() {
      const camera = this.$GLOBAL.map.getCameraView();
      this.$GLOBAL.map
        .expImage({
          download: false,
          width: 300,
        })
        .then((result) => {
          console.log(result, "resultresultresult");
          BimViewPntsDetailEdit({
            viewPntsId: this.viewpointForm.id,
            lat: camera.lat,
            lng: camera.lng,
            alt: camera.alt,
            heading: camera.heading,
            pitch: camera.pitch,
            image: result.image,
          }).then((res) => {
            this.$notify({
              title: "视角更新成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.getData();
            this.ifPhotoGraphic = false;
            this.modalNode.viewpoint.head.fold.state = true;
          });
        });
    },
    onSubmitViewpoint() {
      if (!this.isGlobal) {
        this.viewpointForm.speed = Number(this.viewpointForm.speed);
        this.viewpointForm.lastingTime = Number(this.viewpointForm.lastingTime);
        if (
          this.viewpointForm.speed <= 0 ||
          this.viewpointForm.lastingTime <= 0
        ) {
          this.$message({
            message: "速度或时间不能小于0",
            type: "warning",
          });
          return;
        }
      }
      BimViewPntsDetailEdit({
        name: this.viewpointForm.name,
        viewPntsId: this.viewpointForm.id,
        speed: this.viewpointForm.speed,
        lastingTime: this.viewpointForm.lastingTime,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.getData();
        // this.viewpointNode.newGroupingCategory.show = false;
        this.viewpointNodeShow = false;
        this.ifPhotoGraphic = false;
      });
    },
    closeViewpoint() {
      // this.viewpointNode.newGroupingCategory.show = false;
      this.viewpointNodeShow = false;
      this.ifPhotoGraphic = false;
    },
    getTime() {
      var now = new Date();
      var yy = now.getFullYear(); //年
      var mm = now.getMonth() + 1; //月
      var dd = now.getDate(); //日
      var hh = now.getHours(); //时
      var ii = now.getMinutes(); //分
      var ss = now.getSeconds(); //秒
      var time = yy + "";
      if (mm < 10) time += "0";
      time += mm + "";
      if (dd < 10) time += "0";
      time += dd + "";
      if (hh < 10) time += "0";
      time += hh + "";
      if (ii < 10) time += "0";
      time += ii + "";
      if (ss < 10) time += "0";
      time += ss;

      return time;
    },
  },
  mounted() {
    this.setIntervals = null;
    this.setTimeouts = null;
    this.getData();

    viewpointMap.createdGraphicLayer();
  },
  destroyed() {
    sessionStorage.removeItem("savePerspectiveId");
  },
};
